// Description tab jquery
$('body').on('click', 'li[data-tab="tab-1"]', function() {
	$('#tab-1').show();
    $('#tab-2').hide();
	$(this).addClass('active');  
    $('li[data-tab="tab-2"]').removeClass('active');  
});
$('body').on('click', 'li[data-tab="tab-2"]', function() {
	$('#tab-2').show();
    $('#tab-1').hide();
	$(this).addClass('active');  
    $('li[data-tab="tab-1"]').removeClass('active');  
});

/*
$(document).ready(function() {
  //BY SUHAS
  $("#style-dropdown input[type='radio']").change(function(){
    console.log('main drop changed');
    setTimeout(function(){
        var variantPrice = $(".price_in_cta").html();
      alert(variantPrice);
        $("#length-dropdown input[type='radio'] + label .vprice_2").html(variantPrice);
    }, 2000);
    
  });
});  
*/

//Displaying image alt text on image
$("ul.product__media-list li").each(function(){
    var alttxt = $(this).find(".product__media img").attr("alt");
    //alert(alttxt);
    $(this).find(".imageInfo").html(alttxt);
});

    

// ADD ENGRAVING POPUP
$('body').on('click', '.add_eng', function() {
    $('#machine_popup').fadeIn('fast');
    $('body').addClass('hide-scroll');
});
$('body').on('click', '.close_popup, .button-box .button, .popup-over', function() {
    $('.product-popup').fadeOut('fast');
    $('body').removeClass('hide-scroll');
});

// Hand engraving  POPUP
$('body').on('click', '.add_handeng', function() {
    $('#hand_popup').fadeIn('fast');
    $('body').addClass('hide-scroll');
});


// Chain guide POPUP
$('body').on('click', '.chain-popup-link', function() {
    $('.necklaces-info-popup').fadeIn('fast');
    $('body').addClass('hide-scroll');
});
$('body').on('click', '.close_popup2, .popup-over', function() {
  $('.necklaces-info-popup').fadeOut('fast');
    $('body').removeClass('hide-scroll');
});

// Drop a hint POPUP
$('body').on('click', '.drop-hint', function() {
    $('.drophint-popup').fadeIn('fast');
    $('body').addClass('hide-scroll');
});
$('body').on('click', '.close_hintpopup, .drophint-over', function() {
  $('.drophint-popup').fadeOut('fast');
    $('body').removeClass('hide-scroll');
});


// Size guide POPUP
$('body').on('click', '.sizeguide-popup-link', function() {
    $('#sizeguide_popup').fadeIn('fast');
    $('body').addClass('hide-scroll');
});





// Machine Engraving filed blank check

$('body').on('click', '#ck_1', function() {
//alert('1')
  /**/
  if( $('#line-1').val().length === 0 ) {
        $('.line-erroe-1').show();
    } else {
        $('.line-erroe-1').hide();
    }

  //check if second textfield available on page or not
  if( $('#SecondTxtFields').length){
    
   if( $('#line-2').val().length === 0 ) {
        $('.line-erroe-2').show();
    } else {
       $('.line-erroe-2').hide();
    }


    $(".line-2 input").on("input",function(){
        
        if($(this).val() == ''){
            //alert('blank again');
            $('#ck_1').show();
        } else {
          //alert('no blank again');
          if($("#note-2:checkbox").is(":checked")) {
              $('.popup-ck-1').hide();  
              $('#ck_1').hide();    
          }
        }
    })

    
  }
  
  if($("#note-1").prop('checked')) {
        $('.popup-ck-1').hide();        
   } else {    
      $('.popup-ck-1').show();        
   }
  
  if($("#note-2").prop('checked')) {
        $('.popup-ck-2').hide();        
   } else {
      $('.popup-ck-2').show();        
   }
  
});

$(".line-1 input").on("input",function(){
        
        if($(this).val() == ''){
            //alert('blank again');
            $('#ck_1').show();
        } else {
          //alert('no blank again');
          if($("#note-1:checkbox").is(":checked")) {
              $('.popup-ck-1').hide();  
              $('#ck_1').hide();    
          }
        }
    })

$('body').on('change', '#note-1:checkbox', function() {
    if($(this).is(":checked")) {

    if ($(".line-1 input").val() == '') {
        $('#ck_1').show(); 
    } else if ($(".line-2 input").val() == '') {
        $('#ck_1').show(); 
    } else {    
        $('.popup-ck-1').hide();  
        $('#ck_1').hide();    
    }
    }  else {
        $('#ck_1').show();    
    }
});
$('body').on('change', '#note-2:checkbox', function() {
    if($(this).is(":checked")) {
        $('.popup-ck-2').hide();  
     //  $('#ck_1').hide();        
    } else {
        //$('#ck_1').show();    
    }
});

$('body').on('keypress', '#line-1', function() {
     $('.line-erroe-1').hide();
});
$('body').on('keypress', '#line-2', function() {
     $('.line-erroe-2').hide();
});

$('body').on('click', '.tpo_shape_square', function() {
   setTimeout(function(){
    $('.product-popup').fadeOut('fast');
      }, 1000);
    $('body').removeClass('hide-scroll');
      setTimeout(function(){
      $(".product-form__submit").trigger("click");
      }, 1200);
});


// ADD TO CART CHECKBOX ERROR
$('body').on('click', '.selectcheckbox', function() {
 $('.error-checkbox').show();
// $(this).hide();
});

$('body').on('change', '.note-text input:checkbox', function() {
    if($(this).is(":checked")) {
        $('.selectcheckbox').hide();
         $('.error-checkbox').hide();
    } else {
        $('.selectcheckbox').show();
    }
});


// Chain dropdown
$('body').on('click', '.chain-box', function() {
    $('#chain-dropdown').slideToggle('fast');
    $('#size-dropdown').slideUp('fast');
    $('#style-dropdown').slideUp('fast');
    $('#zodiac-dropdown').slideUp('fast');  
    
    $(this).toggleClass('active');
    $('.size-box').removeClass('active');
    $('.styledp-box').removeClass('active');
    $('.zodiac-box').removeClass('active'); 
  
    $('#option_chain').toggleClass('active');
    $('#option_size').removeClass('active');
    $('#option_style').removeClass('active');
    $('#option_zodiac').removeClass('active');
    
});
$('body').on('click', '#chain-dropdown label', function() {
    $('#chain-dropdown').slideUp('fast');
    $('.chain-box').removeClass('active');
    var labelhtml = $(this).attr('data-value');
    $('.chain-box i').html(labelhtml);  
    $('.chain-box').attr('data-val', labelhtml);  
    $('#option_chain').removeClass('active');

  

});

// Size dropdown
$('body').on('click', '.size-box', function() {    
    $('#chain-dropdown').slideUp('fast');
    $('#size-dropdown').slideToggle('fast');
    $('#style-dropdown').slideUp('fast');
    $('#zodiac-dropdown').slideUp('fast');
    
    $(this).toggleClass('active');
    $('.chain-box').removeClass('active');
    $('.styledp-box').removeClass('active');
    $('.zodiac-box').removeClass('active'); 
  
    $('#option_chain').removeClass('active');
    $('#option_size').toggleClass('active');
    $('#option_style').removeClass('active');
    $('#option_zodiac').removeClass('active');
});
$('body').on('click', '#size-dropdown label', function() {
    $('#size-dropdown').slideUp('fast');
    $('.size-box').removeClass('active');
    var labelhtml2 = $(this).attr('data-value');
    $('.size-box i').html(labelhtml2);
   $('.chain-box').attr('data-val', labelhtml2);  
    $('#option_size').removeClass('active');
});

// Style dropdown
$('body').on('click', '.styledp-box', function() {
    $('#chain-dropdown').slideUp('fast');
    $('#size-dropdown').slideUp('fast');
    $('#style-dropdown').slideToggle('fast');
    $('#zodiac-dropdown').slideUp('fast');
    
    $(this).toggleClass('active');
    $('.chain-box').removeClass('active');
    $('.size-box').removeClass('active');
    $('.zodiac-box').removeClass('active'); 
  
    $('#option_chain').removeClass('active');
    $('#option_size').removeClass('active');
    $('#option_style').toggleClass('active');
    $('#option_zodiac').removeClass('active');
});
$('body').on('click', '#style-dropdown label', function() {
    $('#style-dropdown').slideUp('fast');
    $('.styledp-box').removeClass('active');
    var labelhtml = $(this).attr('data-value');
    $('.styledp-box i').html(labelhtml);
    $('.styledp-box').addClass(labelhtml);
    $('.styledp-box').attr('data-val', labelhtml);  
    $('#option_style').removeClass('active');
});

// Zodiac dropdown
$('body').on('click', '.zodiac-box', function() {
    $('#chain-dropdown').slideUp('fast');
    $('#size-dropdown').slideUp('fast');
    $('#style-dropdown').slideUp('fast');
    $('#zodiac-dropdown').slideToggle('fast');
    
    $(this).toggleClass('active');
    $('.chain-box').removeClass('active');
    $('.size-box').removeClass('active');
    $('.styledp-box').removeClass('active');
  
    $('#option_chain').removeClass('active');
    $('#option_size').removeClass('active');
    $('#option_zodiac').removeClass('active');
    $('#option_style').toggleClass('active');

});
$('body').on('click', '#zodiac-dropdown label', function() {
    $('#zodiac-dropdown').slideUp('fast');
    $('.zodiac-box').removeClass('active');
    var labelhtml = $(this).attr('data-value');
    $('.zodiac-box i').html(labelhtml);
    $('#option_zodiac').removeClass('active');
});


// Length dropdown
$('body').on('click', '.length-box', function() {
    $('#chain-dropdown').slideUp('fast');
    $('#size-dropdown').slideUp('fast');
    $('#style-dropdown').slideUp('fast');
    $('#zodiac-dropdown').slideUp('fast');
    $('#length-dropdown').slideToggle('fast');
    
    $(this).toggleClass('active');
    $('.chain-box').removeClass('active');
    $('.size-box').removeClass('active');
    $('.styledp-box').removeClass('active');
    $('.zodiac-box').removeClass('active');
  
    $('#option_chain').removeClass('active');
    $('#option_size').removeClass('active');
    $('#option_zodiac').removeClass('active');
    $('#option_style').removeClass('active');
    $('#option_length').toggleClass('active');

});
$('body').on('click', '#length-dropdown label', function() {
    $('#length-dropdown').slideUp('fast');
    $('.length-box').removeClass('active');
    var labelhtml = $(this).attr('data-value');
    $('.length-box i').html(labelhtml);
    $('#option_length').removeClass('active');
});




$(document).ready(function() {


  $(".size-guide-header").insertBefore('.popup_text_1');
$("#necklaces_table").insertAfter('.popup_text_1');
$("#chain-bracelets_table").insertAfter('.popup_text_2');
$("#hinged-bracelets_table").insertAfter('.popup_text_3');
$("#rings_table").insertAfter('.popup_text_4');
  
  
// FONT CHNAGE 
$('#Serif:radio').change(function(){
if($(this).is(":checked")) {
    $('.machine-input input').addClass("input-Serif");
    $('.machine-input input').removeClass("input-Script");       
} else {
    $('.machine-input input').removeClass("input-Serif");
}
    $("input#Script").prop("checked", false).trigger('click');
    $("input#Script").removeAttr("checked");
});
  
$('#Script:radio').change(function(){
if($(this).is(":checked")) {
    $('.machine-input input').addClass("input-Script");
    $('.machine-input input').removeClass("input-Serif");        
} else {
    $('.machine-input input').removeClass("input-Script");
}
    $("input#Serif").prop("checked", false).trigger('click');
    $("input#Serif").removeAttr("checked");
});

// POPUP IMAGES
    $(".engraving-images").prependTo("#row-id-1");
    $(".hand-engraving-wrappper").prependTo("#row-id-2");  


/*
var vp1 = $('span.vprice_1').html(); $('#chain-dropdown .vprice_1,  #style-dropdown .vprice_1').html(vp1);
var vp2 = $('span.vprice_2').html(); $('#chain-dropdown .vprice_2,  #style-dropdown .vprice_2').html(vp2);
var vp3 = $('span.vprice_3').html(); $('#chain-dropdown .vprice_3,  #style-dropdown .vprice_3').html(vp3);
var vp4 = $('span.vprice_4').html(); $('#chain-dropdown .vprice_4,  #style-dropdown .vprice_4').html(vp4);
var vp5 = $('span.vprice_5').html(); $('#chain-dropdown .vprice_5,  #style-dropdown .vprice_5').html(vp5);
var vp6 = $('span.vprice_6').html(); $('#chain-dropdown .vprice_6,  #style-dropdown .vprice_6').html(vp6);
var vp7 = $('span.vprice_7').html(); $('#chain-dropdown .vprice_7,  #style-dropdown .vprice_7').html(vp7);
var vp8 = $('span.vprice_8').html(); $('#chain-dropdown .vprice_8,  #style-dropdown .vprice_8').html(vp8);
var vp9 = $('span.vprice_9').html(); $('#chain-dropdown .vprice_9,  #style-dropdown .vprice_9').html(vp9);
var vp10 = $('span.vprice_10').html(); $('#chain-dropdown .vprice_10,  #style-dropdown .vprice_10').html(vp10);
var vp11 = $('span.vprice_11').html(); $('#chain-dropdown .vprice_11,  #style-dropdown .vprice_11').html(vp11);
var vp12 = $('span.vprice_12').html(); $('#chain-dropdown .vprice_12,  #style-dropdown .vprice_12').html(vp12);
var vp13 = $('span.vprice_13').html(); $('#chain-dropdown .vprice_13,  #style-dropdown .vprice_13').html(vp13);
var vp14 = $('span.vprice_14').html(); $('#chain-dropdown .vprice_14,  #style-dropdown .vprice_14').html(vp14);
var vp15 = $('span.vprice_15').html(); $('#chain-dropdown .vprice_15,  #style-dropdown .vprice_15').html(vp15);
var vp16 = $('span.vprice_16').html(); $('#chain-dropdown .vprice_16,  #style-dropdown .vprice_16').html(vp16);
var vp17 = $('span.vprice_17').html(); $('#chain-dropdown .vprice_17,  #style-dropdown .vprice_17').html(vp17);*/

var vp1 = $('span.vprice_1').html(); $('#length-dropdown .vprice_1').html(vp1);
var vp2 = $('span.vprice_2').html(); $('#length-dropdown .vprice_2').html(vp2);
var vp3 = $('span.vprice_3').html(); $('#length-dropdown .vprice_3').html(vp3);
var vp4 = $('span.vprice_4').html(); $('#length-dropdown .vprice_4').html(vp4);
var vp5 = $('span.vprice_5').html(); $('#length-dropdown .vprice_5').html(vp5);
var vp6 = $('span.vprice_6').html(); $('#length-dropdown .vprice_6').html(vp6);
var vp7 = $('span.vprice_7').html(); $('#length-dropdown .vprice_7').html(vp7);
var vp8 = $('span.vprice_8').html(); $('#length-dropdown .vprice_8').html(vp8);
var vp9 = $('span.vprice_9').html(); $('#length-dropdown .vprice_9').html(vp9);
var vp10 = $('span.vprice_10').html(); $('#length-dropdown .vprice_10').html(vp10);
var vp11 = $('span.vprice_11').html(); $('#length-dropdown .vprice_11').html(vp11);
var vp12 = $('span.vprice_12').html(); $('#length-dropdown .vprice_12').html(vp12);
var vp13 = $('span.vprice_13').html(); $('#length-dropdown .vprice_13').html(vp13);
var vp14 = $('span.vprice_14').html(); $('#length-dropdown .vprice_14').html(vp14);
var vp15 = $('span.vprice_15').html(); $('#length-dropdown .vprice_15').html(vp15);
var vp16 = $('span.vprice_16').html(); $('#length-dropdown .vprice_16').html(vp16);
var vp17 = $('span.vprice_17').html(); $('#length-dropdown .vprice_17').html(vp17);
  



if(window.location.href.indexOf("ready-to-ship/products") > -1) {
//   $('#option_necklace-style').addClass('hide');
  //  $('#option_length').addClass('hide');
//   $('.selectlength, .selectstyle, .add_engbox, .add_engbox').addClass('hide');



    }

  
if(window.location.href.indexOf("ready-to-ship/products/") > -1) {
//   $('.note-text, .selectcheckbox').addClass('hide');

  var stocklabel_1 = $('.vstock_1').attr('data-stock'); $('.vlabelstock_1').addClass("hidelabelstock_"+stocklabel_1);
  var stocklabel_2 = $('.vstock_2').attr('data-stock'); $('.vlabelstock_2').addClass("hidelabelstock_"+stocklabel_2);
  var stocklabel_3 = $('.vstock_3').attr('data-stock'); $('.vlabelstock_3').addClass("hidelabelstock_"+stocklabel_3);
  var stocklabel_4 = $('.vstock_4').attr('data-stock'); $('.vlabelstock_4').addClass("hidelabelstock_"+stocklabel_4);
  var stocklabel_5 = $('.vstock_5').attr('data-stock'); $('.vlabelstock_5').addClass("hidelabelstock_"+stocklabel_5);
  var stocklabel_6 = $('.vstock_6').attr('data-stock'); $('.vlabelstock_6').addClass("hidelabelstock_"+stocklabel_6);
  var stocklabel_7 = $('.vstock_7').attr('data-stock'); $('.vlabelstock_7').addClass("hidelabelstock_"+stocklabel_7);
  var stocklabel_8 = $('.vstock_8').attr('data-stock'); $('.vlabelstock_8').addClass("hidelabelstock_"+stocklabel_8);
  var stocklabel_9 = $('.vstock_9').attr('data-stock'); $('.vlabelstock_9').addClass("hidelabelstock_"+stocklabel_9);
  var stocklabel_10 = $('.vstock_10').attr('data-stock'); $('.vlabelstock_10').addClass("hidelabelstock_"+stocklabel_10);
  var stocklabel_11 = $('.vstock_11').attr('data-stock'); $('.vlabelstock_11').addClass("hidelabelstock_"+stocklabel_11);
  var stocklabel_12 = $('.vstock_12').attr('data-stock'); $('.vlabelstock_12').addClass("hidelabelstock_"+stocklabel_12);
  var stocklabel_13 = $('.vstock_13').attr('data-stock'); $('.vlabelstock_13').addClass("hidelabelstock_"+stocklabel_13);

  
 }



  
  
  
});

// inquire POPUP 

$('body').on('click', '.inquire_btn', function() {
    $('.inquire_popup').fadeIn('fast');
    $('body').addClass('hide-scroll');
});
$('body').on('click', '.close_inpopup, .inpopup-over', function() {
  $('.inquire_popup').fadeOut('fast');
    $('body').removeClass('hide-scroll');
});


$('body').on('click', '.selectsize', function() {
    $('.error-div3').show();    
});
$('body').on('click', '#size-dropdown label', function() {
    $('.error-div3').hide();   
    $('.selectsize').hide(); 
});

$('body').on('click', '.selectchain', function() {
    $('.error-div1').show();    
});
$('body').on('click', '#chain-dropdown label', function() {
    $('.error-div1').hide();   
    $('.selectchain').hide(); 
});

$('body').on('click', '.selectstyle', function() {
    $('.error-div2').show();    
});
$('body').on('click', '#style-dropdown label', function() {
    $('.error-div2').hide();   
    $('.selectstyle').hide(); 
});

$('body').on('click', '.selectzodiac', function() {
    $('.error-div4').show();    
});
$('body').on('click', '#zodiac-dropdown label', function() {
    $('.error-div4').hide();   
    $('.selectzodiac').hide(); 
});

$('body').on('click', '.selectcolor', function() {
    $('.error-div5').show();    
});
$('body').on('click', '#option_color label, #option_color input', function() {
    $('.error-div5').hide();   
    $('.selectcolor').hide(); 
});

$('body').on('click', '.selectlength', function() {
    $('.error-div6').show();    
});
$('body').on('click', '#option_length label, #option_length input', function() {
    $('.error-div6').hide();   
    $('.selectlength').hide(); 
});



$("#option_length input").prop("checked", false);
$("#option_color input").prop("checked", false);
$(".note-text input").prop("checked", false);


(function() {

    $('body').on('click', 'label.tpo_shape_square', function() {  
    if($('.tpo_buttons-input').hasClass('tpo_checked')){
        $(".tpo_option-set-wrapper").prepend("<div id='hideme' style='position: absolute;left: 0;top: 12px;width: 100%;height: 78px;z-index: 9999;display: inherit;'></div>");
    }
});
  $(document).ready(function() {
    update();
  });

  

  //code check
  function update() { 





    //move engvagin button inside machin engraving popup
    $(".tpo_option-set-wrapper").prependTo("#machine_popup #custom_btn_wrapper");
    $(".product-additional-price").prependTo("label.tpo_shape_square");
    $(".tpo_additional-price").prependTo("label.tpo_shape_radius");  

    //assign $55 price to Add to Cart CTA from option wrapper
    var additionalPrice = $(".tpo_option-label-container .form__label span").html();
    //alert(additionalPrice);
    $("#additional_price_display").html(additionalPrice);

    //on add engraving button click, display "+ $55" amount in CTA
    $('body').on('click', '.tpo_shape_square', function() {   
      //alert('1');
    if($('.tpo_shape_square').hasClass('tpo_is_checked_buttons')){
      $("#additional_price_display").show();
    } else {
      $("#additional_price_display").hide();
    }
    });
    
    setTimeout(update, 2500);     
  }
  
  }
)();


setTimeout(function(){
  //alert('1');
  
}, 2500);

/**/

setTimeout(function(){
var additionalPrice = $(".tpo_option-label-container .form__label span").html();
//alert(additionalPrice);
$("#additional_price_display").html(additionalPrice);
}, 3200);


//see if price assigned or not
setTimeout(function(){
if($("#additional_price_display").html() == ''){
  alert(additionalPrice);
var additionalPrice = $(".tpo_option-label-container .form__label span").html();

$("#additional_price_display").html(additionalPrice);
}
}, 3300);





   $('#option_necklace-style label.option_pendant-only').on('click', function() {
    // alert('1');
     $(".selectlength").addClass('hide');
     $(".error-div6").addClass('hide-err');
    //  $("#option_length").addClass('hide'); 
     
    // $(".option_not-applicable").trigger('click');
     //  $("input[value='Not Applicable']").trigger('click');

      setTimeout(function(){
      $("#option_length .option_pendant-only").trigger('click');  
     $("#option_length input[value='Pendant Only']").trigger('click');
        }, 200);
     $(this).parent('div').parent('div').parent('fieldset').addClass('pendant-only_active');   
});


 $('#option_style label.option_pendant-only').on('click', function() {
    // alert('1');
     $(".selectlength").addClass('hide');
     $(".error-div6").addClass('hide-err');
    //  $("#option_length").addClass('hide'); 
     
    // $(".option_not-applicable").trigger('click');
     //  $("input[value='Not Applicable']").trigger('click');

      setTimeout(function(){
      $("#option_length .option_pendant-only").trigger('click');  
     $("#option_length input[value='Pendant Only']").trigger('click');
        }, 200);
     $(this).parent('div').parent('div').parent('fieldset').addClass('pendant-only_active');   
});


   $('.vardropdown_section label:not(.option_pendant-only)').on('click', function() {
     $(".selectlength").removeClass('hide');
     $(".error-div6").removeClass('hide-err');
     $(".error-div6").hide();

     setTimeout(function(){
     $("#option_length").removeClass('hide');
}, 500);
   
    // $("#length-dropdown label:nth-child(2)").trigger('click');
    //  $("#length-dropdown .option_18").trigger('click');

     $(this).parent('div').parent('div').parent('fieldset').removeClass('pendant-only_active');
 
});




   $('.stone-box input').on('click', function() {
     $('.stone-box input').not(this).removeAttr('checked');
     $(this).attr('checked', 'checked');
});

$(document).on('click', '#option_necklace-style label:not(.option_pendant-only)', function() {
  // alert(1);
  $("#length-wrap label:nth-child(4)").trigger('click');
   });

$(document).on('click', '.vardropdown_section label', function() {
  $('.product-form__submit > span, .cta_price_wrapper').css('opacity', '0');
   setTimeout(function(){
    $('.product-form__submit > span, .cta_price_wrapper').css('opacity', '1');
}, 1000);
});






